import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-licenses-page',
  templateUrl: './licenses-page.component.html',
  styleUrls: ['./licenses-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicensesPageComponent {}
